import Loader from './Loader';

// export types
export type { LoaderProps } from './Loader';

// export components
export { Loader };
export default Loader;
